import { action, observable } from 'mobx';
import ConfigRepository from '../ConfigRepository';
import STATUS from '../../constants/Status';
import Api from '../../api';

interface ITncRepositoryConfig {
  configRepository: ConfigRepository;
  api: Api;
}

class TncRepository {
  @observable status = STATUS.IDLE;

  @observable configRepository: ConfigRepository;

  @observable tncHtmlContent: string;

  private api: Api;

  constructor(config: ITncRepositoryConfig) {
    this.configRepository = config.configRepository;
    this.api = config.api;
  }

  @action
  private setStatus(status: STATUS): void {
    this.status = status;
  }

  @action
  public async loadTncHtmlContent(): Promise<void> {
    const { tncContentNodeId } = this.configRepository.config;

    if (this.status === STATUS.IDLE || this.status === STATUS.ERROR) {
      try {
        this.setStatus(STATUS.LOADING);
        this.tncHtmlContent = await this.api.getHtmlContent(Number(tncContentNodeId));
        this.setStatus(STATUS.LOADED);
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
        this.setStatus(STATUS.ERROR);
      }
    }
  }
}

export default TncRepository;
